<template>
  <span
    class="activity-type-icon"
    :class="[`activity-type-icon--${size}`, `activity-type-icon--${variant}`]"
    aria-hidden="true"
  >
    <svg
      class="activity-type-icon__glyph"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        v-for="(path, index) in paths"
        :key="index"
        :d="path.d"
        :transform="path.transform"
        :class="{
          'activity-type-icon__cutout': path.cutout,
          'activity-type-icon__outlined': path.outline,
        }"
      />
    </svg>
  </span>
</template>

<script>
import ACTIVITY_TYPE_ICONS from './activityTypeIcons';

export default {
  name: 'OpportunityActivityTypeIcon',
  props: {
    type: {
      type: String,
      default: 'other',
    },
    size: {
      type: String,
      default: 'normal',
    },
    variant: {
      type: String,
      default: 'solid',
    },
  },
  computed: {
    paths() {
      return ACTIVITY_TYPE_ICONS[this.type] || ACTIVITY_TYPE_ICONS.other;
    },
  },
};
</script>

<style lang="scss" scoped>
.activity-type-icon {
  --activity-icon-background: #1e3a8a;
  --activity-icon-color: var(--white);

  align-items: center;
  background: var(--activity-icon-background);
  border-radius: var(--border-radius-normal);
  display: inline-flex;
  flex-shrink: 0;
  height: 4rem;
  justify-content: center;
  width: 4rem;
}

.activity-type-icon--small {
  border-radius: var(--border-radius-small);
  height: 2.4rem;
  width: 2.4rem;
}

.activity-type-icon--soft {
  --activity-icon-background: var(--s-100);
  --activity-icon-color: var(--s-700);
}

.activity-type-icon__glyph {
  fill: var(--activity-icon-color);
  height: 62%;
  width: 62%;
}

.activity-type-icon__cutout {
  fill: var(--activity-icon-background);
}

.activity-type-icon__outlined {
  paint-order: stroke;
  stroke: var(--activity-icon-background);
  stroke-width: 2.4;
}
</style>
